import { MatchLabel } from "../Match";
import "./MatchLineups.scss";
import NoData from "@/components/client/NoData";
import SOCCER_FIELD from '@/assets/images/soccer-field.svg';
import { Image } from '@/lib/target';
import { Tooltip } from "@nextui-org/react";
import clsx from "clsx";

const MatchLineups = ({ match }) => {
  if (!match) {
    return (<NoData/>);
  }

  const matchFinised = Number( match?.status ) === -1;
  
  
  return (
    <>  
    <div className="mt-8">
      <MatchLabel label={'Đội hình xuất phát'}/>
      <div className="rounded overflow-hidden lineup-world">
      {match?.lineUps?.length > 0 && match?.lineUps[0]?.homeFormation && match?.lineUps[0]?.awayFormation  ?  (<Lineup lineup={match?.lineUps}/>) : (matchFinised ? <NoData message="Không có dữ liệu"/> : <NoData/>)}
      </div>
    </div>
    </>
  );
};

const Lineup = ({ lineup }) => {
  if (!lineup || lineup.length === 0) {
    return <></>;
  }
  
  const homeTeam = lineup[0]?.playerLineUps?.filter((el) => el.type === 'home').sort((a, b) => a.position - b.position);
  const awayTeam = lineup[0]?.playerLineUps?.filter((el) => el.type === 'away').sort((a, b) => a.position - b.position);
  
  const homeTeamBackup = lineup[0]?.playerLineUps?.filter((el) => el.type === 'homeBackup').sort((a, b) => a.position - b.position);
  const awayTeamBackup = lineup[0]?.playerLineUps?.filter((el) => el.type === 'awayBackup').sort((a, b) => a.position - b.position);

  return (
    <div className="grid grid-cols-12 gap-3 pt-2">
    <div className="col-span-12 @lg:col-span-8 relative lineup-world">
      <div className="relative js-stage stage texture ">
        <div className=" js-world world">
          <div className="team js-team p-4 w-full">
            <div className="team-home flex max-h-1/2 mb-10">
                <LineupsTemplate startXI={homeTeam}/>
            </div>
            <div className="team-away flex flex-col max-h-1/2 mt-10">
                <LineupsTemplate startXI={awayTeam} away={true}/>
            </div>
          </div>
          <div className="terrain js-terrain  bg-white p-4 shadow-xl">
            <div className="ground">
              <Image src={SOCCER_FIELD} alt="field" width={590} height={1000} className="w-full"/>
            </div>
          </div>
        </div>
      </div>
      
    </div> 
    <div className="hidden @lg:flex col-span-4 backups flex-col">
        <div className="backups__home team-home w-full h-1/2  overflow-y-scroll">
          <div className="font-semibold rounded-md bg-button-blue-bet text-white px-2 text-sm h-[26px] flex items-center">
            HOME
          </div>
          <BackupTemplate backup={homeTeamBackup}/>
        </div>
        <div className="backups__away team-away w-full h-1/2 overflow-y-scroll">
        <div className="font-semibold rounded-md bg-gradient-start text-button-blue-bet px-2 text-sm h-[26px] flex items-center">
            AWAY
          </div>
          <BackupTemplate backup={awayTeamBackup} away={true} />
        </div>
      </div>
    </div>

  );
};



const BackupTemplate = ({ backup, away=false }) => {
  return (
    <div className="gap-4 max-h-[535px] overflow-scroll">
      {backup.map((player) => (
        <GenerateSubPlayerTemplate key={player.id} player={player} away={away} />
      ))}
    </div>
  );
};


const LineupsTemplate = ({ startXI, away = false }) => {
  const layerClassList = 'flex flex-row items-center justify-around h-full gap-2 @sm:gap-4 @md:gap-7 ';

  const renderLineups = () => {
    let currentLineNum = 0;
    let currentLinePlayers = [];
    const template = [];
    const lineups = away ? startXI.reverse() : startXI;

    lineups.forEach((player) => {
      const playerPos = player.position;

      if (currentLineNum !== playerPos) {
        if (currentLinePlayers.length > 0) {
          template.push(
            <div key={currentLineNum} className={layerClassList}>
              {currentLinePlayers}
            </div>
          );
        }
        currentLinePlayers = [<GeneratePlayerTemplate key={player.id} player={player} />];
        currentLineNum = playerPos;
      } else {
        currentLinePlayers.push(<GeneratePlayerTemplate key={player.id} player={player} />);
      }
    });

    if (currentLinePlayers.length > 0) {
      template.push(
        <div key={currentLineNum} className={layerClassList}>
          {currentLinePlayers}
        </div>
      );
    }

    return template;
  };

  return (
    <div className="team-template flex flex-col justify-between @md:py-3 @lg:py-0 px-10">
      {renderLineups()}
    </div>
  );
};


const GenerateSubPlayerTemplate = ({ player, away=false }) => {
  return (
    <div className={clsx("items flex rounded-md  mt-2 h-10 items-center px-4 shadow-md", {
      "bg-white" : !away,
      "bg-yellow-pastel": away
    })}>
      {/* <div className="w-6"><Image alt={player.name} src={PHONGDO_UP width={20} height={18}/></div> */}
      <div className="w-auto font-semibold">
        <div className="mb-1">
          <span className="text-black mr-1">{player.number}</span>
          <span className="text-button-blue-bet truncate">
            <Tooltip showArrow={true} content={player.name} className="bg-sm-dark-gray rounded px-2 ">
              <span className="@lg:w-64 truncate "> {player.name}</span>
            </Tooltip>
            </span>
          </div>
          {player?.players.playerStats?.rating && 
        <div className="text-[10px] text-white bg-button-blue-bet w-max px-[3px] rounded-[2px] font-bold">{player?.players.playerStats?.rating}</div>
      }
      </div>
    </div>
  );
};

const GeneratePlayerTemplate = ({ player }) => {
  return (
    <div className="player flex flex-col items-center text-xs">
      <div className="relative">
        <div className="w-[35px] h-[35px] @sm:w-[40px] @sm:h-[40px] @md:w-[50px] @md:h-[50px] rounded-full bg-white overflow-hidden flex justify-center">
          <Image 
            src={player.players.photo || 'https://demofree.sirv.com/nope-not-here.jpg'} 
            alt={player.name} 
            width={35} 
            height={35}
            layout="responsive"
            loading="lazy"
            // objectFit="contain"
            // sizes="(max-width: 768px) 20px, (max-width: 1200px) 50px"
          />
        </div>
        <div className="absolute w-5 h-5 @sm:w-6 @sm:h-6 rounded-full bottom-0 -right-1.5 bg-white border-button-blue-bet border-solid border-2">
          <div className="number text-xxs @lg:text-xs text-button-blue-bet font-semibold flex justify-center items-center h-full">{player.number}</div>
        </div>
      </div>
      
      <div className="player__name text-center text-header-blue text-xxs @lg:text-xs w-12 @md:w-20 truncate ">
        <Tooltip showArrow={true} content={player.name} className="bg-sm-dark-gray rounded px-2 ">
          <span className="@lg:w-28 truncate font-semibold"> {player.name}</span>
        </Tooltip>
      </div>
    </div>
  );
};


export default MatchLineups;